import type { ContactDetailsGet } from "@/domain/contactdetails/getContactDetails"
import { isNotBlank, isNullOrUndefined } from "@/utils/ts-utils"

import { EMPTY_PLACEHOLDER } from "../constants"

export const ADDRESS_FORMAT = {
  FULL: "FULL",
  FULL_2LINES: "FULL_2LINES",
  ADD_123: "ADD_123",
  CP_CITY_COUNTRY: "CP_CITY_COUNTRY",
  CP_CITY: "CP_CITY",
} as const

export function formatAddress(
  ctd: ContactDetailsGet | undefined,
  format: keyof typeof ADDRESS_FORMAT,
  dft: string = EMPTY_PLACEHOLDER
): string {
  const line: string[] = []
  const line2: string[] = []

  if (isNullOrUndefined(ctd)) return dft

  switch (format) {
    case ADDRESS_FORMAT.FULL:
      if (isNotBlank(ctd.address1)) line.push(ctd.address1)
      if (isNotBlank(ctd.address2)) line.push(ctd.address2)
      if (isNotBlank(ctd.address3)) line.push(ctd.address3)
      if (isNotBlank(ctd.zipcode)) line.push(ctd.zipcode)
      if (isNotBlank(ctd.city)) line.push(ctd.city)
      if (isNotBlank(ctd.country)) line.push(line.length > 0 ? `(${ctd.country})` : ctd.country)

      return line.length > 0 ? line.join(" ") : dft
    case ADDRESS_FORMAT.FULL_2LINES:
      if (isNotBlank(ctd.address1)) line.push(`${ctd.address1} `)
      if (isNotBlank(ctd.address2)) line.push(`${ctd.address2} `)
      if (isNotBlank(ctd.address3)) line.push(`${ctd.address3} `)
      if (isNotBlank(ctd.zipcode)) line2.push(`${ctd.zipcode} `)
      if (isNotBlank(ctd.city)) line2.push(`${ctd.city} `)
      if (isNotBlank(ctd.country)) line2.push(line2.length > 0 ? `(${ctd.country})` : ctd.country)

      return line.length > 0 || line2.length > 0 ? `${line.join(" ")}\n${line2.join(" ")}` : dft
    case ADDRESS_FORMAT.ADD_123:
      if (isNotBlank(ctd.address1)) line.push(ctd.address1)
      if (isNotBlank(ctd.address2)) line.push(ctd.address2)
      if (isNotBlank(ctd.address3)) line.push(ctd.address3)

      return line.length > 0 ? line.join(" ") : dft
    case ADDRESS_FORMAT.CP_CITY_COUNTRY:
      if (isNotBlank(ctd.zipcode)) line.push(ctd.zipcode)
      if (isNotBlank(ctd.city)) line.push(ctd.city)
      if (isNotBlank(ctd.country)) line.push(line.length > 0 ? `(${ctd.country})` : ctd.country)

      return line.length > 0 ? line.join(" ") : dft
    case ADDRESS_FORMAT.CP_CITY:
      if (isNotBlank(ctd.zipcode)) line.push(ctd.zipcode)
      if (isNotBlank(ctd.city)) line.push(ctd.city)

      return line.length > 0 ? line.join(" ") : dft
    default:
      return dft
  }
}
